module.exports = __webpack_public_path__ + "img/vertical_7_6_7005.77348652.png";